<!-- <div id="parent" class="stf-logcat-table force-gpu" style="scrollbar-width: thin;">
  <table class="console-message-text tableX table-condensed selectable" style="height: 9px;">
    <tbody id="logContent" style="height: 9px; overflow-y: auto;"></tbody>
  </table>
</div> -->
<div id="parent" class="stf-logcat-table force-gpu" #scrollMe [scrollTop]="scrollMe.scrollHeight">
  <table class="console-message-text tableX table-condensed selectable" style="height: 63vh;">
    <tbody id="logBody" style="height: 9px; "></tbody>
  </table>
</div>

<ng-template #SaveLogs_message let-modal>
  <div class="stf-save-log-message stf-modal">
    <div class="modal-header dialog-header-errorX">
      <h4 class="modal-title text-danger"><i class="fa fa-save"></i>
        <div class="button-spacer"></div><span>{{"Save Logs" | translate}}</span>
      </h4>
      <button class="btn btn-sm btn-danger close" type="button" (click)="cancel()">&times;</button>

    </div>
    <div class="modal-body">
      <table class="table" ng-show="true">
        <tr class="additional-modal">
          <td width="50%">
            <input class="input-sm form-control" [(ngModel)]="saveLogFileName" type="text"
              placeholder="{{&quot;File Name&quot;|translate}}" />
          </td>
          <td width="1%"><span>.</span></td>
          <td width="20%">
            <select [(ngModel)]="selectedExtension" value="json" (change)="logtype($event)">
              <option class="log">json</option>
              <option class="excel">xlsx</option>
            </select>

          </td>
        </tr>
        <tr class="additional-modal">
        <tr class="additional-modal">
          <td width="100%">
            <h5 class="modal-title bold"><span>{{"Sample of log format" | translate}}</span></h5>
          </td>
        </tr>
        <tr class="additional-modal">
          <td width="50%" height="30%">
            <textarea class="save-log-textarea" [(ngModel)]="samplePresentation" type="text" placeholder="..." rows="4"
              readonly="readonly"></textarea>
          </td>
          <td width="5%" colspan="2"><i class="fa fa-file-text-o fa-5x"></i></td>
        </tr>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-success" (click)="saveLogs()" ng-disabled="false">
        <i class="fa fa-save"></i>
        <span>{{" Save Logs" | translate}}</span>
      </button>
    </div>
  </div>

</ng-template>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>